export default "__VITE_ASSET__8b9e27ba__"